var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.blockType === _vm.BT.BOT_RESPONSE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.BOT_RESPONSE },
        },
        [_vm._v(" send ")]
      )
    : _vm.blockType === _vm.BT.START_POINT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.START_POINT },
        },
        [_vm._v(" home ")]
      )
    : _vm.blockType === _vm.BT.ATTACHMENT_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.ATTACHMENT_INPUT },
        },
        [_vm._v("\n    attachment\n")]
      )
    : _vm.blockType === _vm.BT.FILTER
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FILTER },
        },
        [_vm._v(" filter_alt ")]
      )
    : _vm.blockType === _vm.BT.USER_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.USER_INPUT },
        },
        [_vm._v("\n    record_voice_over\n")]
      )
    : _vm.blockType === _vm.BT.GO_TO_STEP
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.GO_TO_STEP },
        },
        [_vm._v(" cable ")]
      )
    : _vm.blockType === _vm.BT.ADD_TO_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.ADD_TO_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BT.REMOVE_FROM_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.REMOVE_FROM_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BT.DEFAULT_FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.DEFAULT_FALLBACK },
        },
        [_vm._v("\n    heart_broken\n")]
      )
    : _vm.blockType === _vm.BT.FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FALLBACK },
        },
        [_vm._v(" heart_broken ")]
      )
    : _vm.blockType === _vm.BT.QUESTION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.QUESTION },
        },
        [_vm._v(" quiz ")]
      )
    : _vm.blockType === _vm.BT.SET_ATTRIBUTE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SET_ATTRIBUTE },
        },
        [_vm._v("\n    data_object\n")]
      )
    : _vm.blockType === _vm.BT.ASSIGN_OWNER
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.ASSIGN_OWNER },
        },
        [_vm._v("\n    person_pin_circle\n")]
      )
    : _vm.blockType === _vm.BT.CLOSE_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CLOSE_CHAT },
        },
        [_vm._v("\n    mark_chat_read\n")]
      )
    : _vm.blockType === _vm.BT.SUCCESS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUCCESS },
        },
        [_vm._v(" check_circle ")]
      )
    : _vm.blockType === _vm.BT.FAILURE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FAILURE },
        },
        [_vm._v(" cancel ")]
      )
    : _vm.blockType === _vm.BT.FLOW
    ? _c(
        "span",
        { staticClass: "material-icons", attrs: { "data-type": _vm.BT.FLOW } },
        [_vm._v("schema")]
      )
    : _vm.blockType === _vm.BT.PLATFORM_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.PLATFORM_FLOW },
        },
        [_vm._v("schema")]
      )
    : _vm.blockType === _vm.BT.CREATE_TICKET
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_TICKET },
        },
        [_vm._v("\n    local_activity\n")]
      )
    : _vm.blockType === _vm.BT.TAG_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TAG_CHAT },
        },
        [_vm._v(" bookmark ")]
      )
    : _vm.blockType === _vm.BT.REMOVE_TAG
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.REMOVE_TAG },
        },
        [_vm._v("\n    bookmark_remove\n")]
      )
    : _vm.blockType === _vm.BT.TRANSFER_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TRANSFER_CHAT },
        },
        [_vm._v("\n    support_agent\n")]
      )
    : _vm.blockType === _vm.BT.TRANSFER_TO_CHATBOT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TRANSFER_TO_CHATBOT },
        },
        [_vm._v("\n    fast_forward\n")]
      )
    : _vm.blockType === _vm.BT.SEND_TRANSCRIPT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_TRANSCRIPT },
        },
        [_vm._v("\n    attach_email\n")]
      )
    : _vm.blockType === _vm.BT.SEND_SMS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_SMS },
        },
        [_vm._v(" sms ")]
      )
    : _vm.blockType === _vm.BT.SEND_MAIL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_MAIL },
        },
        [_vm._v(" mail ")]
      )
    : _vm.blockType === _vm.BT.CREATE_EVENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_EVENT },
        },
        [_vm._v(" event ")]
      )
    : _vm.blockType === _vm.BT.CREATE_RESERVATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_RESERVATION },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_OPEN_URL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_OPEN_URL },
        },
        [_vm._v("\n    event\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_SELECT_DAY
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_SELECT_DAY },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_EVENT_LIST
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_EVENT_LIST },
        },
        [_vm._v("\n    event_note\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_SELECT_TIME
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_SELECT_TIME },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.WEBHOOK
    ? _c(
        "span",
        {
          staticClass: "material-icons text-light",
          attrs: { "data-type": _vm.BT.WEBHOOK },
        },
        [_vm._v(" share ")]
      )
    : _vm.blockType === _vm.BT.API_REQUEST
    ? _c(
        "span",
        {
          staticClass: "material-icons text-light",
          attrs: { "data-type": _vm.BT.API_REQUEST },
        },
        [_vm._v("\n    share\n")]
      )
    : _vm.blockType === _vm.BT.GET_LOCATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.GET_LOCATION },
        },
        [_vm._v("\n    location_on\n")]
      )
    : _vm.blockType === _vm.BT.SET_DEPARTMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SET_DEPARTMENT },
        },
        [_vm._v("\n    category\n")]
      )
    : _vm.blockType === _vm.BT.TAVILY_WEB_SEARCH
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TAVILY_WEB_SEARCH },
        },
        [_vm._v("\n    search\n")]
      )
    : _vm.blockType === _vm.BT.OPENAI_WEB_SEARCH
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OPENAI_WEB_SEARCH },
        },
        [_vm._v("\n    search\n")]
      )
    : _vm.BT.AKINON_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: { src: "/static/img/akinon.png", "data-type": _vm.blockType },
      })
    : _vm.BT.IDEASOFT_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: { src: "/static/img/ideasoft.webp", "data-type": _vm.blockType },
      })
    : _vm.BT.PROBEL_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/probel.png",
          "data-type": _vm.blockType,
        },
      })
    : _vm.blockType === _vm.BT.SHOPIFY_ORDER_STATUS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BT.SHOPIFY_ORDER_STATUS,
        },
      })
    : _vm.blockType === _vm.BT.SHOPIFY_PRODUCT_AVAILABILITY
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BT.SHOPIFY_PRODUCT_AVAILABILITY,
        },
      })
    : _vm.blockType === _vm.BT.SHOPIFY_SHOW_PRODUCTS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BT.SHOPIFY_SHOW_PRODUCTS,
        },
      })
    : _vm.blockType === _vm.BT.AI_BOT_RESPONSE ||
      _vm.blockType === _vm.BT.AI_FUNCTIONS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/openai.png",
          "data-type": _vm.BT.AI_BOT_RESPONSE,
        },
      })
    : _vm.blockType === _vm.BT.AI_ASSISTANT
    ? _c(
        "div",
        {
          staticClass: "custom-block-logo ai-assistant",
          attrs: { "data-type": _vm.BT.AI_ASSISTANT },
        },
        [_c("OpenaiIcon")],
        1
      )
    : _vm.blockType === _vm.BT.FEEDBACK_AI_ASSISTANT
    ? _c(
        "div",
        {
          staticClass: "custom-block-logo ai-assistant",
          attrs: { "data-type": _vm.BT.FEEDBACK_AI_ASSISTANT },
        },
        [_c("OpenaiIcon")],
        1
      )
    : _vm.blockType === _vm.BT.INSERT_TO_SYSTEM_PROMPT
    ? _c(
        "div",
        {
          staticClass: "custom-block-logo ai-assistant",
          attrs: { "data-type": _vm.BT.INSERT_TO_SYSTEM_PROMPT },
        },
        [_c("OpenaiIcon")],
        1
      )
    : _vm.blockType === _vm.BT.CREATE_TASK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_TASK },
        },
        [_vm._v(" add_task ")]
      )
    : _vm.blockType === _vm.BT.SUPPRESSION_ADD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUPPRESSION_ADD },
        },
        [_vm._v("\n    block\n")]
      )
    : _vm.blockType === _vm.BT.SUPPRESSION_REMOVE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUPPRESSION_REMOVE },
        },
        [_vm._v("\n    lock_open\n")]
      )
    : _vm.blockType === _vm.BT.B2CARGO_PRODUCT_STATUS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/b2cargo.png",
          "data-type": _vm.BT.B2CARGO_PRODUCT_STATUS,
        },
      })
    : _vm.blockType === _vm.BT.B2CARGO_LOGIN_USER
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/b2cargo.png",
          "data-type": _vm.BT.B2CARGO_LOGIN_USER,
        },
      })
    : _vm.blockType === _vm.BT.DEFAULT_TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.DEFAULT_TIMEOUT },
        },
        [_vm._v("\n    timer\n")]
      )
    : _vm.blockType === _vm.BT.TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TIMEOUT },
        },
        [_vm._v(" timer ")]
      )
    : _vm.blockType === _vm.BT.SEND_WP_BUSINESS_MESSAGE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_WP_BUSINESS_MESSAGE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm.blockType === _vm.BT.MESSENGER_SEND_MESSAGE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.MESSENGER_SEND_MESSAGE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm.blockType === _vm.BT.INSTAGRAM_SEND_MESSAGE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.INSTAGRAM_SEND_MESSAGE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm.blockType === _vm.BT.B2CARGO_LOGIN_USER
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/b2cargo.png",
          "data-type": _vm.BT.B2CARGO_LOGIN_USER,
        },
      })
    : _vm.blockType === _vm.BT.HOLIDAY_PLUS_GET_HOTELS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/holidayplus.png",
          "data-type": _vm.BT.HOLIDAY_PLUS_GET_HOTELS,
        },
      })
    : _vm.blockType === _vm.BT.HOLIDAY_PLUS_GET_ROOMS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/holidayplus.png",
          "data-type": _vm.BT.HOLIDAY_PLUS_GET_ROOMS,
        },
      })
    : _vm.blockType.startsWith("ZOHO")
    ? _c("ZohoIcon", {
        staticClass: "material-icons zoho",
        attrs: { "data-type": _vm.blockType },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_REPLY
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_REPLY },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_DELETE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_DELETE },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_SHOW
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_SHOW },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_HIDE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_HIDE },
      })
    : _vm.blockType === _vm.BT.AI_INSTAGRAM_FLOW
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_INSTAGRAM_FLOW },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE },
      })
    : _vm.blockType === _vm.BT.AI_MENU_FLOW
    ? _c("AIClassificationIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_MENU_FLOW },
      })
    : _vm.blockType === _vm.BT.AI_CLASSIFICATION
    ? _c("AIClassificationIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_CLASSIFICATION },
      })
    : _vm.blockType === _vm.BT.TSOFT_ORDER_STATUS ||
      _vm.blockType === _vm.BT.TSOFT_SELECT_ORDER
    ? _c("TsoftIcon", {
        staticClass: "custom-block-logo",
        staticStyle: { width: "30px" },
        attrs: { "data-type": _vm.BT.TSOFT_ORDER_STATUS },
      })
    : _vm.BT.IKAS_BLOCKS && _vm.BT.IKAS_BLOCKS.includes(_vm.blockType)
    ? _c("IkasIcon", {
        staticClass: "custom-block-logo",
        staticStyle: { width: "30px" },
        attrs: { "data-type": _vm.blockType },
      })
    : _vm.BT.TICIMAX_V2_BLOCKS &&
      _vm.BT.TICIMAX_V2_BLOCKS.includes(_vm.blockType)
    ? _c("TicimaxIcon", {
        staticClass: "custom-block-logo",
        staticStyle: { width: "30px" },
        attrs: { "data-type": _vm.blockType },
      })
    : _vm.blockType === _vm.BT.OTP_WHATSAPP_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_WHATSAPP_FLOW },
        },
        [_vm._v("\n    sms\n")]
      )
    : _vm.blockType === _vm.BT.OTP_SMS_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_SMS_FLOW },
        },
        [_vm._v(" sms ")]
      )
    : _vm.blockType === _vm.BT.OTP_MAIL_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_MAIL_FLOW },
        },
        [_vm._v(" mail ")]
      )
    : _vm.blockType === _vm.BT.TABLE_CREATE_RECORD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TABLE_CREATE_RECORD },
        },
        [_vm._v("\n    add_circle\n")]
      )
    : _vm.blockType === _vm.BT.TABLE_UPDATE_RECORD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TABLE_UPDATE_RECORD },
        },
        [_vm._v("\n    edit\n")]
      )
    : _vm.blockType === _vm.BT.TABLE_DELETE_RECORD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TABLE_DELETE_RECORD },
        },
        [_vm._v("\n    delete\n")]
      )
    : _vm.blockType === _vm.BT.TABLE_FIND_RECORD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TABLE_FIND_RECORD },
        },
        [_vm._v("\n    search\n")]
      )
    : _vm.blockType === _vm.BT.TABLE_FIND_RECORDS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TABLE_FIND_RECORDS },
        },
        [_vm._v("\n    list\n")]
      )
    : _vm.blockType === _vm.BT.AI_CALL
    ? _c(
        "span",
        {
          staticClass: "material-icons voice-agent-icon",
          attrs: { "data-type": _vm.BT.AI_CALL },
        },
        [_vm._v("\n    record_voice_over\n")]
      )
    : _vm.blockType === _vm.BT.RUN_JAVASCRIPT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RUN_JAVASCRIPT },
        },
        [_vm._v("\n    code\n")]
      )
    : _vm.blockType === _vm.BT.CACHE_WRITE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CACHE_WRITE },
        },
        [_vm._v("\n    save\n")]
      )
    : _vm.blockType === _vm.BT.CACHE_READ
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CACHE_READ },
        },
        [_vm._v("\n    download\n")]
      )
    : _vm.blockType === _vm.BT.CACHE_EXTEND
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CACHE_EXTEND },
        },
        [_vm._v("\n    update\n")]
      )
    : _vm.blockType === _vm.BT.CACHE_DELETE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CACHE_DELETE },
        },
        [_vm._v("\n    delete_forever\n")]
      )
    : _vm.blockType === _vm.BT.CUSTOM_BLOCK
    ? _c(
        "span",
        {
          staticClass: "material-icons custom-block-icon",
          attrs: { "data-type": _vm.BT.CUSTOM_BLOCK },
        },
        [_vm._v("\n    " + _vm._s(_vm.customBlockIcon || "extension") + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }